import { render, staticRenderFns } from "./ProjectCardState.vue?vue&type=template&id=b8ad2502&scoped=true"
import script from "./ProjectCardState.vue?vue&type=script&lang=js"
export * from "./ProjectCardState.vue?vue&type=script&lang=js"
import style0 from "./ProjectCardState.vue?vue&type=style&index=0&id=b8ad2502&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ad2502",
  null
  
)

export default component.exports